import { render, staticRenderFns } from "./Template9.vue?vue&type=template&id=4cfb353c&scoped=true&"
import script from "./Template9.vue?vue&type=script&lang=js&"
export * from "./Template9.vue?vue&type=script&lang=js&"
import style0 from "./Template9.vue?vue&type=style&index=0&id=4cfb353c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfb353c",
  null
  
)

export default component.exports